<template>
    <div class="is-full-width px-5 is-flex">
        <div class="is-flex is-flex-direction-column header_text">
            <p class="classify_title mb-1 is-align-self-flex-start">
                Últimos documentos cargados
            </p>
        </div>
        <div class="" style="margin-left: auto;">
            <button class="close_button" aria-label="Cerrar Modal" @click="$emit('close-modal');">
                <Ecs class="ecs" />
            </button>
        </div>
    </div>
</template>
<script>
import Ecs from "@/components/svg/Ecs.vue";
export default {
    name: "HeaderLastDocuments",
    components: {
        Ecs,
    },
}
</script>
<style scoped>
.ecs {
    width: 100%;
    position: relative;
    height: 20px;
    overflow: hidden;
    flex-shrink: 0;
}

.close_button {
    margin: 0 !important;
    box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
    border-radius: 8px;
    background-color: #fff;
    border: 1px solid #d0d5dd;
    box-sizing: border-box;
    width: 36px;
    height: 36px;
    overflow: hidden;
    padding-top: 5px;
}

.header_text {
    color: var(--Gray-900, #101828);

    font-size: 30px;
    font-style: normal;
    font-weight: 600;
    line-height: 38px;
}
</style>